import React, { useState } from "react";
import CustomModal from "../../../../components/global/CustomModal/CustomModal";
import {
  CloseCircleOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { GoPerson } from "react-icons/go";
import { Form, message, Radio } from "antd";
import CustomButton from "../../../../components/global/Button/CustomButton";
  import useEnrollmentData from "../../../../hooks/EnrollmentsHook/useEnrollmentData";
import { addEnrollment } from "../../../../service/AdminService/enrollmentService";
import { DateField } from "../../../../components/global/DateField/Datefield";
import CustomRadio from "../../../../components/shared/Radio/RadioSelector";
import CustomSearchDropdown from "../../../../components/shared/new Form/Fields/CustomSearchDropdown";

const AddEnrollmentModal = ({ visible, onClose ,setLoading }) => {
  // const [loading, setLoading] = useState(false);
  const [showInfo, setShowInfo] = useState(true);
  const [form] = Form.useForm();
  const enrollmentTarget = Form.useWatch("enrollmentTarget", form);
  const contentType = Form.useWatch("contentType", form);

  const { users, courses, groups, bundles } = useEnrollmentData();
  const userOptions = users.map((u) => ({
    label: `${u.firstName} ${u.lastName}`,
    value: u.userId,
  }));
  const courseOptions = courses.map((c) => ({
    label: c.title,
    value: c.courseId,
  }));

  const groupOptions = groups.map((g) => ({
    label: g.groupName,
    value: g.groupId,
  }));

  const bundleOptions = bundles.map((b) => ({
    label: b.bundleName,
    value: b.bundleId,
  }));

  const onFinish = async (values) => {
    const payload = {
      assignedBy: 1,
      deadline: values.deadline.toISOString(),
      status: "ACTIVE",
    };

    if (values.enrollmentTarget === "group") {
      payload.groupIds = values.groupIds;
    } else {
      payload.userIds = values.userIds;
    }

    if (values.contentType === "curriculum") {
      payload.bundleIds = values.bundleIds;
    } else {
      payload.courseIds = values.courseIds;
    }

    setLoading(true);
    try {
      const response = await addEnrollment(payload);

      if (response.success) {
        message.success(
          response.data.message || "Enrollment created successfully",
        );
      } else {
        message.error(response.message);
      }

      form.resetFields();
      onClose();
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    }
    setLoading(false);
  };
  return (
    <>
      <CustomModal
        onClose={onClose}
        title="Add new Enrollment"
        visible={visible}
      >
        {showInfo && (
          <div className="bg-[#E8F1FF] border border-[#8BBBFF] rounded-[10px] p-4 mb-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2 text-[#025DDE]">
                <ExclamationCircleFilled />
                <p className="font-medium">Enrollment Information</p>
              </div>

              <CloseCircleOutlined
                className="cursor-pointer text-[#025DDE] hover:text-black"
                onClick={() => setShowInfo(false)}
              />
            </div>

            <ul className="list-disc pl-5 text-sm marker:text-[#025DDE]">
              <li className="text-[#025DDE]">
                You can select multiple users and courses
              </li>
              <li className="text-[#025DDE]">
                Deadline is required for all enrollments
              </li>
            </ul>
          </div>
        )}

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
          initialValues={{
            contentType: "course",
            enrollmentTarget: "individual",
          }}
        >
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-4">
              <label style={{ fontWeight: 600 }}>Enrollment Target:</label>
              <Form.Item
                name="enrollmentTarget"
                rules={[{ required: true, message: "Please select a target" }]}
              >
                <Radio.Group className="flex">
                  <CustomRadio value="individual">
                    <div className="flex justify-center items-center gap-1">
                      <GoPerson size={15} color="#910e11" /> Individual User
                    </div>
                  </CustomRadio>
                  <CustomRadio value="group">
                    <div className="flex justify-center items-center gap-1">
                      <GoPerson size={15} color="#910e11" /> Group
                    </div>
                  </CustomRadio>
                </Radio.Group>
              </Form.Item>
            </div>
            <Form.Item
              label={
                enrollmentTarget === "group" ? "Select Groups" : "Select Users"
              }
              name={enrollmentTarget === "group" ? "groupIds" : "userIds"}
              rules={[
                { required: true, message: "Please select at least one" },
              ]}
            >

              <CustomSearchDropdown
              showSelectAll={true}
                multiSelect={true}
                options={
                  enrollmentTarget === "group" ? groupOptions : userOptions
                }
              />
            </Form.Item>

            <div className="flex items-center gap-4">
              <label style={{ fontWeight: 600 }}>Content Type:</label>
              <Form.Item name="contentType" rules={[{ required: true }]}>
                <Radio.Group>
                  <CustomRadio value="course">
                    <div className="flex justify-center items-center gap-1">
                      <GoPerson size={15} color="#910e11" /> Course
                    </div>
                  </CustomRadio>

                  <CustomRadio value="curriculum">
                    <div className="flex justify-center items-center gap-1">
                      <GoPerson size={15} color="#910e11" /> Curriculums
                    </div>
                  </CustomRadio>
                </Radio.Group>
              </Form.Item>
            </div>
            <Form.Item
              label={
                contentType === "curriculum"
                  ? "Select Bundles"
                  : "Select Courses"
              }
              name={contentType === "curriculum" ? "bundleIds" : "courseIds"}
              rules={[
                { required: true, message: "Please select at least one" },
              ]}
            >
              <CustomSearchDropdown
                multiSelect={true}
                options={
                  contentType === "curriculum" ? bundleOptions : courseOptions
                }
              />
            </Form.Item>

            <Form.Item
              label="Deadline"
              name="deadline"
              rules={[{ required: true, message: "Please select a deadline" }]}
            >
              <DateField
                openUpward={true}
                field={{ name: "deadline", label: "" }}
                value={form.getFieldValue("deadline")}
                onChange={(name, value) => {
                  form.setFieldsValue({ [name]: value });
                }}
                onBlur={(name, value) => {
                  form.validateFields([name]);
                }}
                errorMessage={form.getFieldError("deadline")?.[0]}
                clearError={(name) => {
                  form.setFields([
                    {
                      name,
                      errors: [],
                    },
                  ]);
                }}
              />
            </Form.Item>

            <Form.Item>
              <div className="flex w-full gap-2">
                <CustomButton
                  className="w-full"
                  htmlType="submit"
                >
                  Create Enrollment
                </CustomButton>
                <CustomButton
                  onClick={() => onClose()}
                  className="w-full"
                  variant="outlined"
                >
                  {" "}
                  Cancel
                </CustomButton>
              </div>
            </Form.Item>
          </div>
        </Form>
      </CustomModal>
    </>
  );
};

export default AddEnrollmentModal;
